import json from '../../../package.json';
import styles from './version.module.scss';

export default function VersionComponent() {
  return <span className={styles.version}>v{json.version}</span>;
}
